import React,{useEffect} from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import {trackPageView} from '../utils/analytics';
import * as FiIcons from 'react-icons/fi';

const {FiCheck,FiMail,FiClock,FiArrowLeft,FiBook,FiUsers,FiMessageSquare,FiGift,FiStar,FiPlay,FiDownload}=FiIcons;

const FullStackCourseThankYou=()=> {
  useEffect(()=> {
    trackPageView('Full Stack Course Thank You');
  },[]);

  return (
    <div className="min-h-screen bg-white">
      {/* Back to home link */}
      <Link to="/" className="fixed top-4 left-4 z-50 bg-black-900/80 p-2 rounded-full hover:bg-black-900 transition-colors">
        <SafeIcon icon={FiArrowLeft} className="w-5 h-5 text-white" />
      </Link>

      {/* Confetti Effect */}
      <div className="fixed inset-0 pointer-events-none z-10">
        {[...Array(60)].map((_,i)=> (
          <motion.div
            key={i}
            className="absolute w-2 h-2 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full"
            initial={{
              x: Math.random() * window.innerWidth,
              y: -10,
              rotate: 0,
              scale: Math.random() * 0.5 + 0.5
            }}
            animate={{
              y: window.innerHeight + 10,
              rotate: 360,
              scale: 0
            }}
            transition={{
              duration: Math.random() * 3 + 2,
              delay: Math.random() * 2,
              ease: "easeOut"
            }}
          />
        ))}
      </div>

      {/* Hero Section */}
      <section className="pt-20 pb-16 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{scale: 0}}
            animate={{scale: 1}}
            transition={{type: "spring",stiffness: 200,damping: 15}}
            className="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-8"
          >
            <SafeIcon icon={FiCheck} className="w-12 h-12 text-white" />
          </motion.div>

          <motion.h1
            initial={{opacity: 0,y: 30}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.8,delay: 0.2}}
            className="text-4xl md:text-6xl font-bold text-black-900 mb-6 font-serif"
          >
            Payment Successful! 🎉
          </motion.h1>

          <motion.div
            initial={{opacity: 0,y: 20}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 0.4}}
            className="mb-8"
          >
            <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-6 py-3 rounded-full font-semibold mb-6">
              <SafeIcon icon={FiGift} className="w-5 h-5" />
              <span>Welcome to Full Stack Development Course!</span>
            </div>
          </motion.div>

          <motion.p
            initial={{opacity: 0,y: 20}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 0.6}}
            className="text-xl text-black-700 mb-8 max-w-3xl mx-auto leading-relaxed"
          >
            धन्यवाद! तुमचं payment successfully process झालं आहे. आता तुम्ही आमच्या Full Stack Development Course चा भाग आहात!
          </motion.p>
        </div>
      </section>

      {/* Payment Confirmation */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0,y: 30}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 0.8}}
            className="bg-green-50 border border-green-200 rounded-xl p-8 text-center mb-12"
          >
            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={FiCheck} className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-green-800 mb-4">Payment Received & Processing</h2>
            <p className="text-lg text-green-700 mb-4">
              आम्ही तुमचं ₹399 payment receive केलं आहे आणि सध्या ते process करत आहोत.
            </p>
            <div className="bg-white p-4 rounded-lg border border-green-200">
              <p className="text-black-700 font-medium">
                <strong>Course Access:</strong> तुम्हाला 24 तासांच्या आत course access मिळेल तुमच्या email आणि WhatsApp वर.
              </p>
            </div>
          </motion.div>

          {/* What Happens Next */}
          <motion.div
            initial={{opacity: 0,y: 30}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 1.0}}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-black-900 mb-4 font-serif">What Happens Next?</h2>
            <div className="w-16 h-1 bg-black-900 mx-auto mb-8"></div>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <motion.div
              initial={{opacity: 0,y: 20}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.6,delay: 1.2}}
              className="bg-black-50 p-6 rounded-lg text-center"
            >
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiMail} className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Email Confirmation</h3>
              <p className="text-black-700">तुम्हाला confirmation email येईल course details सोबत.</p>
            </motion.div>

            <motion.div
              initial={{opacity: 0,y: 20}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.6,delay: 1.4}}
              className="bg-black-50 p-6 rounded-lg text-center"
            >
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiMessageSquare} className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-2">WhatsApp Access</h3>
              <p className="text-black-700">तुमच्या WhatsApp वर course link आणि login details पाठवले जातील.</p>
            </motion.div>

            <motion.div
              initial={{opacity: 0,y: 20}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.6,delay: 1.6}}
              className="bg-black-50 p-6 rounded-lg text-center"
            >
              <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiBook} className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Course Access</h3>
              <p className="text-black-700">24 तासांच्या आत तुम्हाला full course access मिळेल.</p>
            </motion.div>
          </div>

          {/* Course Timeline */}
          <motion.div
            initial={{opacity: 0,y: 20}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 1.8}}
            className="bg-black-900 text-white p-8 rounded-lg text-center mb-12"
          >
            <div className="flex items-center justify-center mb-4">
              <SafeIcon icon={FiClock} className="w-8 h-8 mr-3" />
              <h3 className="text-2xl font-bold">24-Hour Access Timeline</h3>
            </div>
            <p className="text-lg text-black-200 mb-6">
              आम्ही तुमचं payment verify करून 24 तासांच्या आत तुम्हाला course access देऊ. तुम्हाला email आणि WhatsApp दोन्ही वर message येईल.
            </p>
            <div className="grid md:grid-cols-2 gap-6 mt-6">
              <div className="bg-black-800 p-4 rounded-lg">
                <h4 className="font-semibold mb-2">📧 Email मध्ये मिळेल:</h4>
                <ul className="text-sm text-black-300 text-left">
                  <li>• Course access link</li>
                  <li>• Login credentials</li>
                  <li>• Getting started guide</li>
                  <li>• Bonus materials</li>
                </ul>
              </div>
              <div className="bg-black-800 p-4 rounded-lg">
                <h4 className="font-semibold mb-2">📱 WhatsApp मध्ये मिळेल:</h4>
                <ul className="text-sm text-black-300 text-left">
                  <li>• Direct course link</li>
                  <li>• Quick start instructions</li>
                  <li>• Community group invite</li>
                  <li>• Support contact</li>
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Course Preview */}
      <section className="py-16 bg-black-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0,y: 30}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 2.0}}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-black-900 mb-4 font-serif">What You'll Get Access To</h2>
            <div className="w-16 h-1 bg-black-900 mx-auto mb-8"></div>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {[
              {icon: FiPlay,title: "7 Complete Modules",description: "Step-by-step video lessons मराठी मध्ये"},
              {icon: FiBook,title: "3 Real Projects",description: "Portfolio-ready apps build करा"},
              {icon: FiDownload,title: "Bonus Materials",description: "Templates,cheat sheets & resources"},
              {icon: FiUsers,title: "Community Access",description: "Student community आणि live Q&A"}
            ].map((feature,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 20}}
                animate={{opacity: 1,y: 0}}
                transition={{duration: 0.6,delay: 2.2 + (index * 0.1)}}
                className="bg-white p-6 rounded-lg shadow-sm border border-black-200 text-center"
              >
                <div className="w-12 h-12 bg-black-900 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={feature.icon} className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-semibold text-black-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-black-700">{feature.description}</p>
              </motion.div>
            ))}
          </div>

          {/* Success Stories Preview */}
          <motion.div
            initial={{opacity: 0,y: 20}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 2.6}}
            className="bg-white p-8 rounded-lg shadow-sm border border-black-200"
          >
            <h3 className="text-2xl font-bold text-black-900 mb-6 text-center">Join 500+ Successful Students</h3>
            <div className="grid md:grid-cols-3 gap-6">
              {[
                {
                  text: "मी या course मध्ये शिकलेल्या AI tools वापरून 2 महिन्यात freelancing सुरू केली. आता महिन्याला ₹25,000+ कमवतोय!",
                  name: "Rohit Patil",
                  role: "Student → Freelancer"
                },
                {
                  text: "Interview मध्ये मी live project दाखवला. Same day job offer मिळाला! Salary पण expected पेक्षा जास्त मिळाली.",
                  name: "Priya Sharma",
                  role: "Fresher → Full Stack Developer"
                },
                {
                  text: "Company मध्ये promotion मिळवण्यासाठी हा course perfect होता. Boss impressed झाला माझ्या new skills नी.",
                  name: "Akash Desai",
                  role: "Junior → Senior Developer"
                }
              ].map((testimonial,index)=> (
                <div key={index} className="bg-black-50 p-4 rounded-lg">
                  <div className="flex text-yellow-500 mb-2">
                    {[...Array(5)].map((_,i)=> (
                      <SafeIcon key={i} icon={FiStar} className="w-4 h-4 fill-current" />
                    ))}
                  </div>
                  <p className="text-sm text-black-700 italic mb-3">"{testimonial.text}"</p>
                  <div>
                    <p className="font-semibold text-black-900 text-sm">{testimonial.name}</p>
                    <p className="text-xs text-black-600">{testimonial.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Important Notes */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0,y: 20}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 2.8}}
            className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-8"
          >
            <h3 className="text-xl font-bold text-yellow-800 mb-4 flex items-center">
              <SafeIcon icon={FiClock} className="w-5 h-5 mr-2" />
              Important Information
            </h3>
            <ul className="space-y-2 text-yellow-700">
              <li>• Course access 24 तासांच्या आत activate होईल</li>
              <li>• तुमच्या registered email आणि WhatsApp number वर message येईल</li>
              <li>• Course lifetime access आहे - कधीही expire होणार नाही</li>
              <li>• Community access आणि live Q&A sessions included आहेत</li>
              <li>• कोणताही doubt असेल तर support team available आहे</li>
            </ul>
          </motion.div>

          <motion.div
            initial={{opacity: 0,y: 20}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 3.0}}
            className="text-center"
          >
            <h3 className="text-2xl font-bold text-black-900 mb-4">Need Help?</h3>
            <p className="text-lg text-black-700 mb-6">
              कोणताही प्रश्न असेल तर आम्हाला contact करा:
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="mailto:hello@itskaivalya.com"
                className="flex items-center gap-2 px-6 py-3 bg-black-900 text-white rounded-lg hover:bg-black-800 transition-colors"
              >
                <SafeIcon icon={FiMail} className="w-5 h-5" />
                <span>Email Support</span>
              </a>
              <a
                href="https://wa.me/917418125909"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-6 py-3 border-2 border-black-900 text-black-900 rounded-lg hover:bg-black-100 transition-colors"
              >
                <SafeIcon icon={FiMessageSquare} className="w-5 h-5" />
                <span>WhatsApp Support</span>
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{opacity: 0,y: 20}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 3.2}}
            className="mt-8 text-center"
          >
            <Link to="/">
              <button className="px-6 py-3 bg-black-900 text-white rounded-lg font-semibold hover:bg-black-800 transition-colors">
                Return to Homepage
              </button>
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default FullStackCourseThankYou;